<template>
  <div
    class="dropdown"


    :style="computedStyles"
  >
    <div  v-for=" (stopsInfo,index) in configOptions.categorys" class="dropdown-label-container" @click="stopsInfo.isexpanded = !stopsInfo.isexpanded" :tag="stopsInfo.location">
         <img
      src="/static/images/icon-location.png"
      alt
      width="25.9px"
      height="25.7px"
      align="left"
      style="margin-left: 15px;
             margin-right: 11px;"
    >
      <div class="dropdown-label">
        <span vclass="text" for="busStation" style = "
        font-family: Roboto;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #ffffff;">
          {{ stopsInfo.stopsName }}
        </span>
      </div>



       <div v-expand="stopsInfo.isexpanded" class="options expand "   style = "background-color: #393939;" @click="stopsInfo.isexpanded = false">

      <div
        v-for="option in configOptions.options"
        class="option"
        @click="setCurrentSelectedOption(option);"
        v-if ="option.stopId.indexOf(stopsInfo.stopId) >=0 "

      >
      <div class="onoffswitch" style = "
            margin-left: 31px;
            margin-right: 14px;"
            >
          <input
            type="checkbox"
            name="onoffswitch"
            class="onoffswitch-checkbox"
            :class="option.value"
            v-bind:id="stopsInfo.stopId + '_' + option.value"
            @click="busLine101(stopsInfo.stopId, option.value, option.routeColor); changeOptionSwitch(option.value)"
            :checked="option.switch"
          >
          <label class="onoffswitch-label"  v-bind:for="stopsInfo.stopId + '_' + option.value">
            <span class="onoffswitch-inner"></span>
            <span class="onoffswitch-switch"></span>
          </label>
        </div>
        <div style ="font-family: Roboto;
                     font-size: 12px;
                     font-weight: normal;
                     font-style: normal;
                     font-stretch: normal;
                     line-height: normal;
                     letter-spacing: normal;
                     color: #cccccc;">
                     {{ option.value }}
                     </div>

      </div>
    </div>

      </div>







  </div>
</template>
<script>
import mapoptionsconfig from "@/components/vue-dropdown/config-mapoptions";
//import switchbutton from "@/components/switch";
export default {
  name: "dropdown",
  data() {
    return {
      routesOptions:mapoptionsconfig,
      isBottomSectionToggled: false,
      optionsHeight: 0,
      optionHeight: 35,
      width: 100,

      configOptions: [],
      configOceanOptions : [],
      configYiRoadOptions : [],
      switch2: false,

      backgroundColor: "#cde4f5",
      backgroundExpandedColor: "#fff",
      hoverBackgroundColor: "#0084d4",
      border: "1px solid  #232b35",
      borderRadius: 0,
      textColor: "#fff",

      busStationisExpanded: false,
      oceanisExpanded: false,
      YiRoadisExpanded:false
    };
  },
  components: {},
  props: ["config"],

  computed: {
    computedStyles: function() {
      return [
        { "--options-height": this.optionsHeight + "px" },
        { "--options-height-neg": "-" + this.optionsHeight + "px" },
        { "--option-height": this.optionHeight + "px" },
        //{ "--main-el-border-radius": this.borderRadius },
        //{ "--dropdown-width": this.width + "px" },
        //{ "--dropdown-background-color": this.backgroundColor },
        //{ "--dropdown-expanded-color": this.backgroundExpandedColor },
        //{ "--dropdown-border": this.border },
        //{ "--dropdown-hover-background-color": this.hoverBackgroundColor },
        { "--dropdown-default-text-color": this.textColor }
      ];
    }
  },
  directives: {
    expand: {
      inserted: function(el, binding) {
        if (binding.value !== null) {
          function calcHeight() {
            const currentState = el.getAttribute("aria-expanded");
            el.classList.add("u-no-transition");
            el.removeAttribute("aria-expanded");
            el.style.height = null;
            el.style.height = el.clientHeight + "px";
            el.setAttribute("aria-expanded", currentState);
            setTimeout(function() {
              el.classList.remove("u-no-transition");
            });
          }
          el.classList.add("expand");
          el.setAttribute("aria-expanded", binding.value ? "true" : "false");
          calcHeight();
          window.addEventListener("resize", calcHeight);
        }
      },
      update: function(el, binding) {
        if (el.style.height && binding.value !== null) {
          el.setAttribute("aria-expanded", binding.value ? "true" : "false");
        }
      }
    }
  },
   model: {
    prop: "isEnabled",
    event: "toggle"
  },

  methods: {
    toggle: function() {
      this.$emit("toggle", !this.isEnabled);
    },
    toggleRiskLevelsBusStation() {
      this.busStationisExpanded = !this.busStationisExpanded;
    },
    toggleRiskLevelsOcean() {
      this.oceanisExpanded = !this.oceanisExpanded;
    },
    toggleRiskLevelsYiRoad() {
      this.YiRoadisExpanded = !this.YiRoadisExpanded;
    },
    changeOptionSwitch(optionValue) {
      for (let o=0; o < this.configOptions.options.length; o++) {
        if (this.configOptions.options[o].value === optionValue) {
          this.configOptions.options[o].switch = !this.configOptions.options[o].switch
          return
        }
      }
    },
    setCurrentSelectedOption(option) {
      this.$emit("setSelectedOption", option);
    },
    busLine101(stopId, value, routeColor) {
      this.$emit("busline", {
        stopId: stopId,
        value: value,
        color: routeColor
      });
    },
    setConfigData() {
      this.configOptions = this.config;
      this.configOceanOptions = this.config.oceanOptions;
      this.configYiRoadOptions = this.config.YiRoadOptions;
      this.width = this.config.width;
      this.placeholder = this.config.placeholder;
      if (this.config.backgroundColor) {
        this.backgroundColor = this.config.backgroundColor;
      }
      if (this.config.backgroundExpandedColor) {
        this.backgroundExpandedColor = this.config.backgroundExpandedColor;
      }
      if (this.config.border) {
        this.border = this.config.border;
      }
      if (this.config.hoverBackgroundColor) {
        this.hoverBackgroundColor = this.config.hoverBackgroundColor;
      }
      if (this.config.textColor) {
        this.textColor = this.config.textColor;
      }
      if (this.config.borderRadius) {
        this.borderRadius = this.config.borderRadius;
      }
    },
    setOptionsHeight() {
      this.optionsHeight = this.optionHeight * this.configOptions.length;
    }
  },
  created() {
    this.setConfigData();
    this.setOptionsHeight();
  },
  beforeUdate() {
    // this.setOptionsHeight();
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "./vue-mapdropdown";
.onoffswitch {
    position: relative; width: 24px;
    -webkit-user-select:none; -moz-user-select:none; -ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block; overflow: hidden; cursor: pointer;
    height: 11px; padding: 0; line-height: 11px;
    border: 2px solid #E3E3E3; border-radius: 50px;
    background-color: #000000;
    transition: background-color 0.3s ease-in;
}
.onoffswitch-label:before {
    width: 7px;
    content: "";
    display: block; width: 11px; margin: 0px;
    height: 11px;
    background: #FFFFFF;
    position: absolute; top: 0; bottom: 0;
    border: 2px solid #E3E3E3; border-radius: 50px;
    transition: all 0.3s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label {
    background-color: #FFBB00;
}
.onoffswitch-checkbox:checked + .onoffswitch-label, .onoffswitch-checkbox:checked + .onoffswitch-label:before {
   border-color: #FFBB00;
}
.onoffswitch-checkbox:checked + .onoffswitch-label:before {
    right: 0px;
}

 .bottom-message {
    margin-top: 20px;
    font-size: 125%;
  }


// For switch-button styling
.switch-button-control {
  display: flex;
  flex-direction: row;
  align-items: center;

  .switch-button {
    $switch-button-height: 1.6em;
    $switch-button-color: var(--color);
    $switch-button-border-thickness: 2px;
    $switch-transition: all 0.3s ease-in-out;
    $switch-is-rounded: true;

    height: $switch-button-height;
    width: calc(#{$switch-button-height} * 2);
    border: $switch-button-border-thickness solid $switch-button-color;
    box-shadow: inset 0px 0px $switch-button-border-thickness 0px
      rgba(0, 0, 0, 0.33);
    border-radius: if($switch-is-rounded, $switch-button-height, 0);

    transition: $switch-transition;

    $button-side-length: calc(
      #{$switch-button-height} - (2 * #{$switch-button-border-thickness})
    );

    cursor: pointer;

    .button {
      height: $button-side-length;
      width: $button-side-length;
      border: $switch-button-border-thickness solid $switch-button-color;
      border-radius: if($switch-is-rounded, $button-side-length, 0);
      background: $switch-button-color;

      transition: $switch-transition;
    }

    &.enabled {
      background-color: $switch-button-color;
      box-shadow: none;

      .button {
        background: white;
        transform: translateX(
          calc(#{$button-side-length} + (2 *#{$switch-button-border-thickness}))
        );
      }
    }
  }

  .switch-button-label {
    margin-left: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/vue-dropdown/vue-mapdropdown.vue